import { render, staticRenderFns } from "./ModalCompetition.vue?vue&type=template&id=4939bdac"
import script from "./ModalCompetition.vue?vue&type=script&lang=js"
export * from "./ModalCompetition.vue?vue&type=script&lang=js"
import style0 from "./ModalCompetition.vue?vue&type=style&index=0&id=4939bdac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports